import { injectIntl } from "react-intl";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createSelector } from 'reselect';
import { Link } from "@mui/material";
import { providerDataLanding, resetPage,set } from '../../store/actions/pages';
import { getByName, reset } from '../../store/actions/search';
import ProviderDataPageComponent from './ProviderDataPage';

const selectProviderData = createSelector(
    (state) => state.pages['provider-data-landing'].list,
    (data) => {
        return data
    }
);

const selectPending = createSelector(
    (state) => state.pages,
    (state) => state.search.getByName.pending,
    ( pages, searchPending) => {
        return pages['provider-data-landing'].pending || searchPending
    }
);

export const ProviderDataPage = connect(
    () => {
        return (state, props) => ({
            providerData: selectProviderData(state),
            pending: selectPending(state)
        });
    },
    (dispatch) => ({
        actions: bindActionCreators({
            providerDataLanding: providerDataLanding,
            searchGetByName: getByName,
            searchReset: reset,
            resetPagedTable: resetPage,
            resetCriteriaWaiting: (pageName) => set(pageName, 'waitForCriteriaFilter', false),

        }, dispatch)
    })
)(injectIntl(ProviderDataPageComponent));